import React from 'react';

import { getExperiment } from '@eventbrite/statsig';
import { getRatingsData } from '../api/surfacingRating';

import { useOrganizerContext, useSurfacingExperimentContext } from '../context';

import { SURFACING_RATING_EXPERIMENT } from '../constants';

import type { TSurfacingExperimentVariant } from '../context';

export const OrganizerRatingDataHandler: React.FC = ({ children }) => {
    const { id: organizerId = '' } = useOrganizerContext();
    // prettier-ignore
    const { setVariant, setStarRatingCount, setTotalRatingCount } = useSurfacingExperimentContext();

    React.useEffect(() => {
        const surfacingVariant = getExperiment(
            SURFACING_RATING_EXPERIMENT.experimentName,
            SURFACING_RATING_EXPERIMENT.param,
            SURFACING_RATING_EXPERIMENT.defaultValue,
        );
        setVariant(surfacingVariant as TSurfacingExperimentVariant);
    }, [setVariant]);

    React.useEffect(() => {
        async function fetchRatingsData() {
            try {
                const ratingsData = await getRatingsData(organizerId);
                setStarRatingCount(Number(ratingsData.average ?? 0));
                setTotalRatingCount(Number(ratingsData.total ?? 0));
            } catch (e) {
                console.log('cannot fetch ratings data', e);
            }
        }
        fetchRatingsData();
    }, [organizerId, setStarRatingCount, setTotalRatingCount]);

    return <>{children}</>;
};
